/*
 * 预订管理
 */

const api = {
	getStoreBookingMode: '/store/getStoreBookingMode', //查看店铺预订模式
	setStoreBookingMode: '/store/setStoreBookingMode' //设置店铺预定模式
};

const routes = {
	'/delivery-manage': '预订管理',
};

export {
	api,
	routes,
};
